module.exports = __webpack_public_path__ + "static/media/ottawa-15.fd763e39.jpg";